import React from 'react';
import getConfig from 'next/config';

import PostCategory from '../../PostCategory/PostCategory';
import Divider from '../../Divider/Divider';
import ReadingTime from '../../ReadingTime/ReadingTime';

import { IRelatedPost } from '../../../lib/types';
import { GTM_CLASS, GTM_CLASS_PREFIX } from '../../../lib/constant';

import styles from '../RelatedPost/RelatedPost.module.scss';
import classnames from 'classnames';
import { parseCategories } from '../../../utils/parseCategories';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

interface IProps {
  relatedPosts: IRelatedPost[];
}

const RelatedPost = ({ relatedPosts }: IProps): JSX.Element => {
  return (
    <div className={styles['widget-related-post']}>
      <div className={styles['post__card']}>
        <div className={styles['post__card--header']}>Artikel Terkait Lainnya</div>
        <div className={styles['post__card--body']}>
          <div className={styles['widget-related-post__list']}>
            {relatedPosts && relatedPosts.length > 0 ? (
              relatedPosts.map((post) => {
                return (
                  <div key={post.slug} className={styles['widget-related-post__item']}>
                    <a
                      href={`${BASE_URL_MEDIA}${post.slug}/`}
                      className={classnames(
                        styles['widget-related-post__item-title'],
                        GTM_CLASS.VIEW_MORE_ARTICLE,
                        `${GTM_CLASS_PREFIX}${parseCategories.getSlug(post.categories)}`
                      )}
                      title={post.title}
                    >
                      {post.title}
                    </a>
                    <div className={styles['widget-related-post__item-meta']}>
                      <PostCategory categories={post.categories} />
                      <Divider />
                      <ReadingTime time={post.readingTime} />
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={styles['widget-related-post__item']}>
                Artikel terkait tidak ditemukan
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RelatedPost;
